import _ from 'underscore';

import addAttributionSourcePanelTemplate from 'panels/addAttributionSource/template.html';

class SettingsAttributionsCtrl {
  constructor($scope, attributionSourceService, organizationService, sdkUtils, alertService, modalService, angularSlideOutPanel) {
    this._$scope = $scope;
    this._attributionSourceService = attributionSourceService;
    this._organizationService = organizationService;
    this._sdkUtils = sdkUtils;
    this._alertService = alertService;
    this._modalService = modalService;
    this._angularSlideOutPanel = angularSlideOutPanel;

    this.currentUserOrganization = organizationService.getCurrentOrganization();
    this.loading = true;
    this.attributionSourceDataTableInstance = {};
    this.attributionSourceListDataTableOptions = {
      paginationType: 'full_numbers',
      displayLength: 50,
      order: [
        [2, 'asc']
      ]
    };

    this.linkCopied = function(relationship, $event) {
      if ($event) $event.preventDefault();

      relationship.showCopiedTooltip = true;
    };
    this.getAttribution = function(relationship) {
      return `attributionId=${relationship.id}&attributionType=CUSTOM`;
    };

    this.selectAllAttributionsForm = {
      selected: false
    };

    this.attributionFilterForm = {
      searchTerm: ''
    };

    this.getAttributionSources()
      .then(results => {
        this.attributionSources = results;

        this.loading = false;
      });
  }

  canEditAttributionSource(attributionSource) { //eslint-disable-line
    if (!attributionSource) return null;

    if (attributionSource.type === 'TABLELIST') return false;
    if (attributionSource.type === 'WALKUP') return false;
    if (attributionSource.type !== 'CUSTOM') return false;

    return true;
  }

  filterAttributionList() {
    if (this.attributionSourceDataTableInstance && this.attributionSourceDataTableInstance.DataTable) {
      this.attributionSourceDataTableInstance.DataTable.search(this.attributionFilterForm.searchTerm).draw();
    }
  }

  showMergeAttributionsModal($event) {
    if ($event) $event.preventDefault();

    const selectAttributions = _.where(this.attributionSources, {
      selected: true
    });

    if (!selectAttributions || !selectAttributions.length || selectAttributions.length < 2) {
      this._alertService.error('Must select at least 2 booked bys to merge');

      return;
    }

    if (!selectAttributions || !selectAttributions.length || selectAttributions.length > 10) {
      this._alertService.error('Cannot select more than 10 booked by to merge');

      return;
    }

    this._modalService.mergeAttributions({
        attributions: selectAttributions
      })
      .then(result => {
        if (!result || !result.attribution) return;

        const foundAttribution = _.findWhere(this.attributionSources, {
          id: result.attribution.id
        });

        if (foundAttribution) {
          _.extend(foundAttribution, result.attribution);

          foundAttribution.selected = false; //uncheck the attribution
        }

        this.attributionSources = _.reject(this.attributionSources, attributions => _.contains(result.deletedAttributionIds, attributions.id));

        this._alertService.success('Attributions merged');
      })
      .catch(() => {
        this._alertService.error('There was an error merging attributions');
      });
  }

  selectAttribution() {} //eslint-disable-line

  selectAllAttributions($event) {
    if ($event) $event.preventDefault();

    const selectAttribution = _.findWhere(this.attributionSources, {
      selected: true
    });

    if (!selectAttribution) {
      _.each(this.attributionSources, attribution => {
        attribution.selected = true;
      });
    } else {
      _.each(this.attributionSources, attribution => {
        attribution.selected = false;
      });
    }
  }

  getAttributionSources() {
    return this._attributionSourceService.listByOrganizationId(this.currentUserOrganization.id)
      .catch(response => {
        this._alertService.error(this._sdkUtils.getErrorFromResponse(response));
      });
  }

  getType(attributionSource) { //eslint-disable-line
    if (!attributionSource) return '';
    if (attributionSource.type === 'MEMBER') return 'Staff';
    if (attributionSource.type === 'RELATIONSHIP') return 'Promoter';
    return 'Custom';
  }

  addAttributionSource($event) {
    if ($event) $event.preventDefault();

    const panelInstance = this._angularSlideOutPanel.open({
      template: addAttributionSourcePanelTemplate,
      openOn: 'right',
      controller: 'addAttributionSourcePanelCtrl',
      panelClass: 'attribution-source-panel-bg',
      backdrop: 'static',
      resolve: {
        attributionSource: [
          () => {
            return null;
          }
        ]
      }
    });

    panelInstance.result
      .then(result => {
        if (result === false) return;

        if (result.attributionSource) {
          this.attributionSources.push(result.attributionSource);
        }

        this._alertService.success('Booked By added');
      });
  }

  updateAttributionSource(attributionSource, $event) {
    if ($event) $event.preventDefault();

    const panelInstance = this._angularSlideOutPanel.open({
      template: addAttributionSourcePanelTemplate,
      openOn: 'right',
      controller: 'addAttributionSourcePanelCtrl',
      panelClass: 'attribution-source-panel-bg',
      backdrop: 'static',
      resolve: {
        attributionSource: [
          () => {
            return attributionSource;
          }
        ]
      }
    });

    panelInstance.result
      .then(result => {
        if (result === false) return;

        if (result.attributionSource) {
          _.extend(attributionSource, result.attributionSource);
        }

        this._alertService.success('Booked By updated');
      });
  }

  deleteAttributionSource(attributionSource, $event) {
    if ($event) $event.preventDefault();

    this._modalService.confirmation({
        modalHeader: `Delete Booked By ${attributionSource.name}`,
        modalMessage: 'Are you sure you want to delete this booked by?',
        confirmBtnTxt: 'Delete Booked By',
        confirmingBtnTxt: 'Deleting...',
        size: 'sm'
      })
      .then(result => {
        if (result && result.confirm) {
          this._attributionSourceService.deleteByIdAndOrganizationId(attributionSource.id, this.currentUserOrganization.id)
            .then(() => {
              const index = this.attributionSources.indexOf(attributionSource);

              this.attributionSources.splice(index, 1);

              this._alertService.success('Booked By deleted');
            })
            .catch(response => {
              this._alertService.error(this._sdkUtils.getErrorFromResponse(response));
            })
            .finally(() => {
              result.modalInstance.close();
            });
        }
      })
      .catch(error => {
        console.log(error);
      });
  }
}

SettingsAttributionsCtrl.$inject = [
  '$scope',
  'jsSdk.attributionSource',
  'organizationService',
  'jsSdk.utils',
  'alertService',
  'modalService',
  'angularSlideOutPanel'
];

export default SettingsAttributionsCtrl;



// WEBPACK FOOTER //
// ./src/components/settingsAttributions/settingsAttributionsCtrl.js